import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Typography } from "@material-tailwind/react";
import {
  Container,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  Box,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import http from "../../../services/http-common";
import { setProfileCheckList } from "../../../store/dataFlow/actions";

const SuccessSubscriptionDNA = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { profileCheckList } = useSelector((state) => state.dataFlow);
  const [searchParams] = useSearchParams();
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [tempProfileCheckList, setTempProfileCheckList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user_Id] = useState(searchParams.get("userId") || "");
  const [session_id] = useState(searchParams.get("session_id") || "");
  const [formData, setFormData] = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    gender: "",
    email: user?.email || "",
    phone: user?.attributes?.phone_number
      ? user?.attributes?.phone_number[0]
      : "",
    address: "",
    city: "",
    state: "",
    zip: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    await axios
      .post(
        "https://entheo.info/wp-json/custom-api/v1/place-order-egpt/",
        formData
      )
      .then((response) => {
        setLoading(false);
        setIsOrderPlaced(true);
        toast.success("Order placed successfully!");

        handleUpdateCheckList.mutate();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(false);
        setIsOrderPlaced(false);
      });
  };

  const handleUpdateCheckList = useMutation(
    () => {
      return http.put(
        `user/seeker-checklist/update`,
        {
          kcId: user.id,
          checkList: tempProfileCheckList,
        },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        dispatch(setProfileCheckList(tempProfileCheckList));
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSave();
    setLoading(true);
  };

  useEffect(() => {
    if (profileCheckList && Array.isArray(profileCheckList)) {
      const updatedCheckList = profileCheckList.map((item) =>
        item.text === "Get EntheoDNA checked - Order your test kit!"
          ? { ...item, completed: true }
          : item
      );
      setTempProfileCheckList(updatedCheckList);
    }
  }, [profileCheckList, user_Id, session_id]);
  return (
    <>
      {isOrderPlaced ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            my: "auto",
            mx: "auto",
            pt: { xs: 2, md: 4 },
            pb: { xs: 2, md: 4 },
            textAlign: "center",
          }}
        >
          <CheckCircleIcon className="text-[#34ba87] w-20" />
          <Typography variant="h5" className="my-2">
            PAYMENT SUCCESSFUL!
          </Typography>
          <Typography variant="paragraph" color="blue-gray">
            Thanks for your order!
          </Typography>
        </Container>
      ) : (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            pt: { xs: 2, md: 4 },
            pb: { xs: 2, md: 4 },
            textAlign: "center",
          }}
        >
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              mt: 4,
              width: "100%",
              maxWidth: "600px",
              textAlign: "left",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <FormLabel>First Name</FormLabel>
                  <TextField
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <FormLabel>Last Name</FormLabel>
                  <TextField
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Gender</FormLabel>
                  <TextField
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Email</FormLabel>
                  <TextField
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Phone</FormLabel>
                  <TextField
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Address</FormLabel>
                  <TextField
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <FormLabel>City</FormLabel>
                  <TextField
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <FormLabel>State</FormLabel>
                  <TextField
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <FormLabel>Zip</FormLabel>
                  <TextField
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column-reverse" },
                justifyContent: { sm: "space-between", xs: "start" },
                alignItems: "center",
              }}
            >
              <LoadingButton
                loading={loading}
                size="small"
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  height: "50.65px",
                  mb: "20px",
                  width: "100%",
                }}
                type="submit"
                variant="contained"
              >
                Submit
              </LoadingButton>
            </Box>
          </Box>
        </Container>
      )}
    </>
  );
};

export default SuccessSubscriptionDNA;
